import { Component, OnInit,EventEmitter, Output, Input,SimpleChanges } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { DateUtils } from 'src/app/utils/days-utils';
@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit {
  imgSrc: string;
  @Output() closePopup = new EventEmitter<any>();
  @Input() stopDetail:any
  constructor(private commonService:CommonService, private envService: EnvironmentService) { }

  toggler:any='planned'
  colors = ["#CBDDFB", "#E4F5E9", "#FAE1EA", "#E8C8AF", "#BBE6FF","#FFC6F2","#F4E7C3","#DACFF9","#ACDADA"];

  ngOnInit(): void 
  {
    this.imgSrc = this.envService.getImgSrc();
  console.log("input in the component ",this.stopDetail);
  
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['stopDetail']) {
      console.log("employeesDetailsWithShuttleStops", this.stopDetail);
      if (this.stopDetail.actualArrivalTimeOfStop == 0) 
      {
        this.stopDetail.actualColorClass = 'grey-text'
      }
      if (this.stopDetail.actualArrivalTimeOfStop != 0) 
      {
        if (this.stopDetail.actualArrivalTimeOfStop <= this.stopDetail.plannedArrivalTimeOfStop) {
          this.stopDetail.actualColorClass = 'green-text'
        }
        else {
          this.stopDetail.actualColorClass = 'red-text'
        }
      }
      console.log("Inside Component");
    }
  }
  
 
  onClosePopup()
  {
    this.closePopup.emit({value:false,data:this.stopDetail});
  }
  toggle(check:any)
  {
    if(check=='planned')
    {
      this.toggler='planned'
    }
    else
    {
      this.toggler='unPlanned'
    }
  }

  getShuttleStatus(status: string): { color: string, name: string } {
    switch (status) {
      case 'NOT_BOARDED_YET':
        return { color: '#6A737D', name: 'Not Boarded Yet' };
      case 'PLANNED':
        return { color: '#0937B2', name: 'Planned' };
      case 'ADHOC':
        return { color: '#E65010', name: 'Ad Hoc' };
      case 'NO_SHOW':
        return { color: '#B00020', name: 'No Show' };
      case 'DIFFERENT_SIGNIN_LOCATION':
        return { color: '#D4900C', name: 'Different Sign In Location' };
      default:
        return { color: '', name: '' };
    }
  }

  getConvertedTimeZoneTime(time){
    if(!!time){
    return DateUtils.formatTimeWithZone(time, this.commonService.timeZone, 'HH:mm');
    
    }else {
      return "--";
    }
  }


}
